import { SINGLE_PAGE_TABLE_SKELETON_HEIGHT, SINGLE_PAGE_TABLE_SKELETON_ROWS } from 'Util/constants'
import { LinearProgress, Skeleton } from '@mui/material'
import { Box } from '@mui/system'
import { type ReactNode, useEffect, useState } from 'react'

export default function DelayedLoader({
  loading,
  children,
  height = SINGLE_PAGE_TABLE_SKELETON_HEIGHT,
  rows = SINGLE_PAGE_TABLE_SKELETON_ROWS,
  delay
}: Readonly<{
  loading: boolean
  children: ReactNode
  height?: number
  rows?: number
  delay?: number
}>) {
  const [showLoading, setShowLoading] = useState(loading)

  useEffect(() => {
    if (!showLoading && loading) {
      setShowLoading(true)
    }
    let timeout: NodeJS.Timeout
    if (delay) {
      timeout = setTimeout(() => {
        setShowLoading(false)
      }, delay)
    }
    return () => clearTimeout(timeout)
  }, [delay, loading])

  return (
    <>
      {showLoading && (
        <Box>
          <LinearProgress />
          {Array.from({ length: rows }, (_x, i) => (
            <Skeleton key={i} height={height} animation="wave" />
          ))}
        </Box>
      )}
      <Box style={{ display: showLoading ? 'none' : 'block' }}>{children}</Box>
    </>
  )
}
